/** @format */

import {createContext} from 'react'
const ErrorContext=createContext(null)
export const ErrorProvider=ErrorContext.Provider
export default ErrorContext
